import React, { useEffect, useState } from "react"
import Collapse from "@material-ui/core/Collapse"
import ConditionalWrap from "conditional-wrap"
import { ReactComponent as Search } from "images/icon_search.svg"
import { ReactComponent as CalendarView } from "images/calendar-view.svg"
import { ReactComponent as ListView } from "images/list-view.svg"

const EventFilters = (props) => {
  const { categories, currentFilters, filterChange, viewChange } = props

  const [dropdowns, setDropdowns] = useState({
    categories: false,
  })
  const [windowWidth, setWindowWidth] = useState(0)
  const [openFilters, setOpenFilters] = useState(false)
  const [filters, setFilters] = useState(currentFilters)
  const [selectedCategories, setSelectedCategories] = useState({})

  useEffect(() => {
    window.addEventListener("resize", saveWindowWidth)
    document.addEventListener("load", saveWindowWidth())

    return () => {
      window.removeEventListener("resize", saveWindowWidth)
      document.removeEventListener("load", saveWindowWidth)
    }
  }, [])

  useEffect(() => {
    setFilters(currentFilters)
  }, [currentFilters])

  useEffect(() => {
    if (categories.length) {
      const initialCategories = {}
      categories.forEach((category) => {
        if (!filters.categories.includes(category.name)) {
          initialCategories[category.name] = false
        } else {
          initialCategories[category.name] = true
        }
      })

      setSelectedCategories(initialCategories)
    }
  }, [categories])

  const saveWindowWidth = () => {
    setWindowWidth(window.innerWidth)
  }

  const clearCategories = () => {
    const updatedCategories = { ...selectedCategories }

    const keys = Object.keys(updatedCategories)
    for (const key of keys) {
      updatedCategories[key] = false
    }

    setSelectedCategories(updatedCategories)
    filterChange({
      ...filters,
      categories: [],
    })
  }

  const saveCategories = () => {
    const selectedNames = []

    categories.forEach((category) => {
      if (selectedCategories[category.name]) {
        selectedNames.push(category.name)
      }
    })

    filterChange({
      ...filters,
      categories: selectedNames,
    })
  }

  const searchEvents = (event) => {
    event.preventDefault()

    filterChange(filters)
  }

  const clearSearch = () => {
    const updatedFilters = {
      ...filters,
      query: "",
    }

    setFilters(updatedFilters)
    filterChange(updatedFilters)
  }

  const filterObjects = [
    <div key="categories">
      {Object.keys(selectedCategories).length > 0 && (
        <div key="categories">
          <div className="filters__dropdown event-filters-dropdown">
            <button
              type="button"
              className={dropdowns.category ? "open" : ""}
              onClick={() =>
                setDropdowns({
                  ...dropdowns,
                  categories: !dropdowns.categories,
                })
              }
            >
              Category
            </button>

            <div className="filters__options event-filters-options">
              <Collapse in={dropdowns.categories}>
                <div className="filters__options__inner">
                  <ul>
                    {categories.map((category) => (
                      <li key={category.id}>
                        <label className="filters__option">
                          <input
                            value={selectedCategories[category.name] || false}
                            checked={selectedCategories[category.name]}
                            type="checkbox"
                            onChange={() => {
                              setSelectedCategories({
                                ...selectedCategories,
                                [category.name]:
                                  !selectedCategories[category.name],
                              })
                            }}
                          />
                          <span />
                          <span>{category.name}</span>
                        </label>
                      </li>
                    ))}
                  </ul>

                  <div className="filters__controls">
                    <button
                      type="button"
                      className="filters__control filters__control--clear"
                      onClick={clearCategories}
                    >
                      Clear
                    </button>

                    <button
                      type="button"
                      className="filters__control filters__control--save"
                      onClick={saveCategories}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        </div>
      )}
    </div>,
    <form
      className="filters__search event-filters-search"
      onSubmit={searchEvents}
      key="search"
    >
      <label>
        <span class="sr-only text-black">Search Events</span>
        <input
          name="query"
          type="text"
          placeholder="Search Events"
          value={filters.query}
          onChange={(event) =>
            setFilters({
              ...filters,
              [event.target.name]: event.target.value,
            })
          }
        />
      </label>

      {filters.query && (
        <button type="button" onClick={clearSearch}>
          Clear
        </button>
      )}

      <button type="submit">
        <span class="sr-only text-black">Search</span>
        <Search />
      </button>
    </form>,
    <div className="filters__view events-filters-view" key="calendar">
      <button type="button" onClick={() => viewChange("dayGridMonth")}>
        Calendar View
        <CalendarView />
      </button>
    </div>,
    <div className="filters__view events-filters-view" key="list">
      <button type="button" onClick={() => viewChange("listMonth")}>
        List View
        <ListView />
      </button>
    </div>,
  ]

  return (
    <div className="filters event-filters">
      <button
        className={`filters__open event-filters-open ${
          openFilters ? "filters__open--close event-filters-open--close" : ""
        }`}
        onClick={() => setOpenFilters(!openFilters)}
      >
        Filter Results
      </button>

      <ConditionalWrap
        condition={windowWidth < 1024}
        wrap={(children) => <Collapse in={openFilters}>{children}</Collapse>}
      >
        {filterObjects}
      </ConditionalWrap>
    </div>
  )
}

export default EventFilters
